import React, { useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import { CalendarWeekIcon } from "../../Icons/CalendarWeek";
import { Floating } from "@talentbait/shared-components";
import { CalendarWrapper, DateGroup } from "./DatePicker.styled";
import { Button } from "../../Button";
import { useTranslation } from "react-i18next";
import { Group } from "../../Layout";

const DatePicker = ({
  range,
  setRange,
  mode = "range",
  expandable = true,
  isNewDataVisualization
}) => {
  const { t } = useTranslation();
  const initialMonth = range?.from || new Date();
  const [currentMonth, setCurrentMonth] = useState(initialMonth);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleClear = () => {
    setRange(undefined);
    setCurrentMonth(new Date());
  };

  if (!isNewDataVisualization) return null;

  const calendar = (
    <CalendarWrapper>
      <DayPicker
        captionLayout="label"
        mode={mode}
        selected={range}
        onSelect={setRange}
        month={currentMonth}
        onMonthChange={setCurrentMonth}
        disabled={{ after: new Date() }}
        animate
        showOutsideDays
      />
      <Group justify="space-between" align="center">
        <Button text={t("Clear")} onClick={handleClear} variant="link" />
        <Button id="select-date-button" text={t("Select")} onClick={() => setOpen(false)} />
      </Group>
    </CalendarWrapper>
  );

  if (!expandable) {
    return calendar;
  }

  return (
    <Floating
      open={open}
      onOpenChange={setOpen}
      fill="rgb(171, 180, 244)"
      placement="bottom"
      asChild={false}
      trigger={
        <DateGroup onClick={handleOpen}>
          <CalendarWeekIcon />
          <p>{t("Filter dates")}</p>
        </DateGroup>
      }
      content={calendar}
    />
  );
};

export default DatePicker;
